import { ArrowDownUp } from "lucide-react";
import { useMemo } from "react";
import { Link } from "react-router-dom";

interface ColumnsProps {
  onClickDelete: (data: any) => void;
  handlerUpdate: (data: any) => void;
  columnName: (data: any) => void;
}

const PesticideFarmerColumn = ({
  onClickDelete,
  handlerUpdate,
  columnName,
}: ColumnsProps) => {
  const PesticideFarmerColumn = useMemo(
    () => [
      {
        header: "سال زراعی",
        accessorKey: "crop_year_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("farmer_name")}
          >
            <span>نام کشاورز</span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "farmer_name",
        enableColumnFilter: true,
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("price")}
          >
            <span>قیمت کشاورز</span>
            <span className="text-blue-600 text-[10px]">(ریال)</span>

            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "price",
        enableColumnFilter: true,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("factory_name")}
          >
            <span>نام کارخانه</span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),

        accessorKey: "factory_name",
        enableColumnFilter: true,
      },

      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("commitment_number")}
          >
            <span>شماره تعهد</span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "commitment_number",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("pesticide_name")}
          >
            <span>نام سم</span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "pesticide_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("pesticide_amount")}
          >
            <span> تعداد</span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "pesticide_amount",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "تاریخ ثبت",
        accessorKey: "created_at",
        enableColumnFilter: false,
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link
              to="#!"
              className="flex items-center mr-4 justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                handlerUpdate(data);
              }}
            >
              <span className="rounded p-1 w-20 ml-3 bg-green-600 text-white">
                ویرایش
              </span>
            </Link>
            <Link
              to="#!"
              className="flex items-center mr-4 justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                onClickDelete(data);
              }}
            >
              <span className="rounded p-1 w-20 ml-3 bg-red-800 text-white">
                حذف
              </span>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return PesticideFarmerColumn;
};

export default PesticideFarmerColumn;
